var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"id":"category","options":_vm.categories,"label":"name","multiple":true},on:{"input":_vm.filterTable},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }